import getCookie from "./cookies";
import getUrlParameter from "./getUrlParams";

// set origin
const setOrigin = () => {
  let currentPage = document.querySelector("main"),
    originValue = currentPage.getAttribute("data-lco");
//   if (getUrlParameter("ORIGINE")) {
//     originValue = getUrlParameter("ORIGINE");
//   } else if (
//     getCookie("campaign_cookie") &&
//     JSON.parse(getCookie("campaign_cookie")).ORIGINE
//   ) {
//     originValue = JSON.parse(getCookie("campaign_cookie")).ORIGINE;
//   }
  return originValue;
};

export default setOrigin;
